import { IExperiment } from '../../api/experiments';
import { checkExperiment } from '../isAbExperiment';

export function isInNewNeighborsButtonGroup(experiments: IExperiment[]): boolean {
  return checkExperiment(experiments, 'audience_serp_filters_neighbors', 1);
}
